module.exports = __webpack_public_path__ + "img/Distribution-Wholesale.4b18cc9d.svg";